import { colors } from '../../../shared/styles/baseStyle';

export const button = {
  color: 'white',
  border: 'none',
  borderRadius: 8,
  fontWeight: 600
};
export const buttonItem = { marginBottom: 0, marginTop: 32 };
export const inputItem = { borderRadius: 8 };
export const forgotPasswordButton = {
  display: 'block',
  color: colors.anytimeBlue,
  marginTop: -20,
  padding: 4,
  height: 'auto',
  fontWeight: 'bold'
};

export const forgotPasswordRow = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 8
};
